<script setup lang="ts">
const route = useRoute()
const year = new Date().getFullYear()
const hideFooter = computed(() => route.meta.hideFooter === true)
</script>

<template>
  <NuxtLayout name="guest">
    <div>
      <slot />
    </div>
    <div v-if="!hideFooter" class="mt-2 text-sm text-center">
      © {{ year }} Forgd. All rights reserved. <a href="/terms-conditions" class="text-accent" target="_blank">Terms & Conditions</a>
      <slot name="footer" />
    </div>
  </NuxtLayout>
</template>
